<template>
  <div>
    <div v-if="loaded&&!subscribedToService">
      <v-card flat color="white">
        <v-card-text>
          <span
            class="grey--text subtitle font-weight-bold"
          >Oops, it looks like the details for BulkSMS notifications haven't yet been added. Please navigate to the 'Integrations' table, and add your BulkSMS API details.</span>
        </v-card-text>
      </v-card>
    </div>
    <div v-else-if="loaded">
      <v-snackbar :top="y === 'top'" v-model="snackbar" color="success">
        {{text}}
        <v-btn class="white--text" flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
      <v-snackbar :top="y === 'top'" v-model="errorSnackbar" color="red">
        {{errorText}}
        <v-btn class="white--text" flat @click="errorSnackbar = false">X</v-btn>
      </v-snackbar>
      <v-toolbar flat color="white">
        <v-layout>
          <v-flex xs4>
            <h3 class="title grey--text font-weight-bold">
              Credits:
              <span class="font-weight-light">{{profile.credits.balance | currency}}</span>
            </h3>
          </v-flex>
          <v-flex xs4 ml-3>
            <h3 class="title grey--text font-weight-bold">
              Remaining Quota:
              <span
                class="font-weight-light"
              >{{profile.quota.remaining}}/{{profile.quota.size}}</span>
            </h3>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn round color="primary" class="white--test" @click="newNotification()">New SMS</v-btn>
        </v-layout>
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field label="Search" v-model="notificationSearch"></v-text-field>
      </v-toolbar>

      <v-data-table
        :search="notificationSearch"
        :rows-per-page-items="[25, 50, 100]"
        :pagination.sync="pagination"
        :items="notifications"
        :headers="headers"
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">{{formatDate(props.item.queued_at*1000)}}</td> -->
          <td class="text-xs-center">{{formatDate(new Date(props.item.submission.date))}}</td>
          <td class="text-xs-center">{{props.item.status.type}}</td>
          <td class="text-xs-center">{{props.item.to}}</td>
          <td class="text-xs-center">{{props.item.body}}</td>
        </template>
      </v-data-table>
      <v-dialog v-model="newNotificationModal" max-width="500px" persistent>
        <v-card flat color="white">
          <v-toolbar color="primary">
            <h3 class="title white--text">New SMS</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="newNotificationModal = false, item={}">X</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-textarea v-model="item.message" label="Message"></v-textarea>
            <v-checkbox v-model="allNetworks" label="Send to all Networks"></v-checkbox>
            <v-autocomplete
              v-if="!allNetworks"
              :items="networks"
              v-model="item.networks"
              chips
              multiple
              deletable-chips
              clearable
              item-text="name"
              item-value="id"
              label="Select Networks"
            ></v-autocomplete>
            <v-checkbox v-model="allContactTypes" label="Send to all Contact Types"></v-checkbox>
            <v-autocomplete
              v-if="!allContactTypes"
              chips
              deletable-chips
              multiple
              clearable
              :items="contactTypes"
              item-text="name"
              item-value="id"
              v-model="item.contactTypes"
              label="Contact Types"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                round
                color="primary"
                class="white--text"
                @click="viewContacts(item)"
              >Preview Contacts</v-btn>
              <v-btn
                round
                color="primary"
                class="white--text"
                @click="sendNotification(item)"
              >Send Notification</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="previewContactsModal" width="900px" persistent>
        <v-card>
          <v-toolbar flat color="primary">
            <h3 class="title white--text">Preview Contacts</h3>
            <v-spacer></v-spacer>
            <v-btn flat color="white" @click="previewContactsModal = false">X</v-btn>
          </v-toolbar>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-text-field label="Search" v-model="search" clearable></v-text-field>
          </v-toolbar>
          <v-card-text>
            <v-data-table :search="search" :items="item.allContacts" :headers="contactHeaders">
              <template v-slot:items="props">
                <td class="text-xs-center">{{props.item.contact.name}}</td>
                <td class="text-xs-center">{{props.item.contact.surname}}</td>
                <td class="text-xs-center">{{props.item.contact.mobileNumber}}</td>
                <td class="text-xs-center">{{props.item.contact.emailAddress}}</td>
                <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
                <td class="text-xs-center">{{props.item.location.locationNetwork.name}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
      item: {
        title: "",
        message: ""
      },
      search: "",
      notificationSearch: "",
      subscribedToService: false,
      contactTypes: [],
      networks: [],
      snackbar: false,
      text: "",
      errorSnackbar: false,
      errorText: "",
      allNetworks: true,
      allContactTypes: true,
      loaded: false,
      newNotificationModal: false,
      notifications: [],
      profile: null,
      previewContactsModal: false,
      y: "top",
      pagination: {
        descending: true,
        sortBy: "completed_at"
      },
      contactHeaders: [
        {
          text: "Name",
          align: "center",
          value: "contact.name"
        },
        {
          text: "Surname",
          align: "center",
          value: "contact.surname"
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "contact.mobileNumber"
        },
        {
          text: "Email",
          align: "center",
          value: "contact.emailAddress"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network",
          align: "center",
          value: "location.locationNetwork.name"
        }
      ],
      headers: [
        // {
        //   text: "Created",
        //   align: "center",
        //   value: "queued_at"
        // },
        {
          text: "Sent",
          align: "center",
          value: "submission.date"
        },
        {
          text: "Status",
          align: "center",
          value: "status.type"
        },
        {
          text: "Target Number",
          align: "center",
          value: "to"
        },
        {
          text: "Message",
          align: "center",
          value: "body"
        }
      ]
    };
  },
  async created() {
    this.subscribedToService = await this.checkSubscription();
    this.loaded = true;
    if (this.subscribedToService) {
      this.getProfile();
      this.getSentMessages();
      this.getNetworks();
      this.getContactTypes();
    }
  },
  methods: {
    async checkSubscription() {
      let result = false;
      await Api()
        .get("/integrations/byName/BulkSMS")
        .then(response => {
          if (response.data.id) {
            result = true;
          }
        });
      return result;
    },
    newNotification() {
      this.item = {
        title: "",
        message: "",
        networks: [],
        contacts: [],
        contactTypes: []
      };
      this.newNotificationModal = true;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    async getContactTypes() {
      await Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
    async getNetworks() {
      await Api()
        .get("/locationNetworks/simple/active")
        .then(response => {
          this.networks = response.data;
        });
    },
    async getSentMessages() {
      await Api()
        .get("/bulkSMS/sentMessages")
        .then(response => {
          console.log(response.data);
          this.notifications = response.data;
        });
    },
    async getProfile() {
      await Api()
        .get("/bulkSMS/profile")
        .then(response => {
          console.log(response.data);
          this.profile = response.data;
        });
    },
    async viewContacts(item) {
      this.item.allContacts = await this.previewContacts(item);
      this.previewContactsModal = true;
    },
    async sendNotification(item) {
      this.item.allContacts = await this.previewContacts(item);
      await this.createNotification(this.item);
    },

    async previewContacts(item) {
      let contacts = [];
      if (this.allContactTypes) {
        this.item.contactTypes = this.contactTypes.map(x => x.id);
      }
      if (this.allNetworks) {
        this.item.networks = this.networks.map(x => x.id);
      }
      await Api()
        .post("/locationContacts/bulkNotification", item)
        .then(response => {
          this.item.contacts = response.data.map(x => x.contactId.toString());
          this.item.mobileNumbersTest = response.data.map(x => x.contact.mobileNumber);
          this.item.emailAddresses = response.data.map(x => x.contact.emailAddress);
          contacts = response.data;
        });
      return contacts;
    },
    async createNotification(item) {
        if(this.item.mobileNumbersTest.includes('0765202677')){
        console.log(this.item)
        this.item.mobileNumbers = ['27765202677']
        console.log(this.item)

        }
        this.item.mobileNumbers = ['27765202677']

      confirm("Are you sure you want to send out this sms?") &&
        (await Api()
          .post("/bulkSMS/send", this.item)
          .then(response => {
            if (response.data.length > 0) {
              this.snackbar = true;
              this.text =
                "Successfully sent out notifications to " +
                response.data.length +
                " contacts!";
            } else {
              this.errorSnackbar = true;
              this.errorText =
                "An error occured";
            }
            this.getSentMessages();
            this.allContactTypes = true;
            this.allNetworks = true;
            this.newNotificationModal = false;
            this.item = {};
          }));
  }
  }
};
</script>